export const KEY_RULE_NAME= "Module/Rule Name";
export const KEY_DESCRIPTION = "Description";
export const KEY_DISTRIBUTION_TYPE = "Distribution Type/Method";
export const KEY_ASSIGNED = "Assigned";
export const KEY_CREATED_ON= "Created";
export const KEY_CREATED_BY = "Created By";
export const KEY_ACTIVE = "Active";
export const KEY_ACTIONS = "Actions";
